// NOOVI: Análise Comercial — feature nativa NooviChat (fase-31)
// Módulo Vuex self-contained (mutation strings locais — não toca mutation-types
// compartilhado). Gera análises assíncronas e faz polling até completar.
import CommercialAnalysisAPI from '../../api/commercialAnalysis';

const SET_UI_FLAG = 'commercialAnalysis/SET_UI_FLAG';
const SET_RECORDS = 'commercialAnalysis/SET_RECORDS';
const UPSERT_RECORD = 'commercialAnalysis/UPSERT_RECORD';
const REMOVE_RECORD = 'commercialAnalysis/REMOVE_RECORD';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isGenerating: false,
    isFetchError: false,
  },
};

export const getters = {
  getReports: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getReportById: $state => id =>
    $state.records.find(record => record.id === Number(id)) || null,
};

export const actions = {
  get: async ({ commit }, params = {}) => {
    commit(SET_UI_FLAG, { isFetching: true, isFetchError: false });
    try {
      const { data } = await CommercialAnalysisAPI.list(params);
      commit(SET_RECORDS, data.data || []);
    } catch {
      commit(SET_UI_FLAG, { isFetchError: true });
    } finally {
      commit(SET_UI_FLAG, { isFetching: false });
    }
  },

  generate: async ({ commit }, payload) => {
    commit(SET_UI_FLAG, { isGenerating: true });
    try {
      const { data } = await CommercialAnalysisAPI.generate(payload);
      commit(UPSERT_RECORD, data.data);
      return { record: data.data, cacheHit: Boolean(data.cache_hit) };
    } finally {
      commit(SET_UI_FLAG, { isGenerating: false });
    }
  },

  show: async ({ commit }, id) => {
    const { data } = await CommercialAnalysisAPI.show(id);
    commit(UPSERT_RECORD, data.data);
    return data.data;
  },

  pollStatus: async ({ commit }, id) => {
    const { data } = await CommercialAnalysisAPI.status(id);
    commit(UPSERT_RECORD, data.data);
    return data.data.status;
  },

  delete: async ({ commit }, id) => {
    await CommercialAnalysisAPI.delete(id);
    commit(REMOVE_RECORD, id);
  },
};

export const mutations = {
  [SET_UI_FLAG]($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  [SET_RECORDS]($state, records) {
    $state.records = records;
  },
  [UPSERT_RECORD]($state, record) {
    if (!record || !record.id) return;
    const index = $state.records.findIndex(item => item.id === record.id);
    if (index === -1) {
      $state.records.unshift({ ...record });
    } else {
      $state.records.splice(index, 1, { ...$state.records[index], ...record });
    }
  },
  [REMOVE_RECORD]($state, id) {
    $state.records = $state.records.filter(item => item.id !== Number(id));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
